var v = Object.defineProperty;
var w = (n, t, e) => t in n ? v(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var s = (n, t, e) => w(n, typeof t != "symbol" ? t + "" : t, e);
class c extends Error {
}
c.prototype.name = "InvalidTokenError";
function R(n) {
  return decodeURIComponent(atob(n).replace(/(.)/g, (t, e) => {
    let o = e.charCodeAt(0).toString(16).toUpperCase();
    return o.length < 2 && (o = "0" + o), "%" + o;
  }));
}
function S(n) {
  let t = n.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return R(t);
  } catch {
    return atob(t);
  }
}
function L(n, t) {
  if (typeof n != "string")
    throw new c("Invalid token specified: must be a string");
  t || (t = {});
  const e = t.header === !0 ? 0 : 1, o = n.split(".")[e];
  if (typeof o != "string")
    throw new c(`Invalid token specified: missing part #${e + 1}`);
  let k;
  try {
    k = S(o);
  } catch (h) {
    throw new c(`Invalid token specified: invalid base64 for part #${e + 1} (${h.message})`);
  }
  try {
    return JSON.parse(k);
  } catch (h) {
    throw new c(`Invalid token specified: invalid json for part #${e + 1} (${h.message})`);
  }
}
const p = "credenza_web_sdk:";
function f(n, t) {
  return localStorage.setItem(`${p}${n}`, t);
}
function u(n) {
  return localStorage.getItem(`${p}${n}`);
}
function I(n) {
  return localStorage.removeItem(`${p}${n}`);
}
const E = {
  LOCAL: "local",
  STAGING: "staging",
  PROD: "prod"
}, d = "access_token", g = "refresh_token", _ = "login_provider", a = {
  ERROR: "ERROR",
  INIT: "INIT",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT"
}, i = /* @__PURE__ */ new Map();
let r = 0;
function T(n, t) {
  const e = i.get(n);
  if (e != null && e.length) {
    for (let o = e.length - 1; o >= 0; o--)
      if (e[o].id === t) {
        e.splice(o, 1), i.set(n, e);
        return;
      }
  }
}
function b(n, t) {
  const e = i.get(n) ?? [];
  return r = r + 1, e.push({ callback: t, id: r, once: !0 }), i.set(n, e), () => T(n, r);
}
function m(n, t) {
  const e = i.get(n) ?? [];
  return r = r + 1, e.push({ callback: t, id: r }), i.set(n, e), () => T(n, r);
}
function l(n, t) {
  const e = i.get(n);
  if (e != null && e.length)
    for (const o of e)
      o.callback(t), o.once && T(n, o.id);
}
class O {
  constructor(t) {
    s(this, "clientId");
    s(this, "env");
    s(this, "extensions", []);
    s(this, "oauth");
    s(this, "account");
    s(this, "evm");
    s(this, "sui");
    s(this, "zklogin");
    s(this, "accessToken");
    s(this, "refreshToken");
    s(this, "loginProvider");
    s(this, "once", b);
    s(this, "on", m);
    s(this, "_emit", l);
    this.clientId = t.clientId, this.env = t.env || E.PROD;
    for (const e of t.extensions || [])
      Object.assign(this, { [e.name]: e }), this.extensions.push(e.name);
  }
  async initialize() {
    var t;
    if (this.accessToken = u(d), this.refreshToken = u(g), this.loginProvider = u(_), this.accessToken) {
      const e = L(this.accessToken);
      (!e.exp || e.exp * 1e3 < (/* @__PURE__ */ new Date()).getTime()) && this.logout();
    }
    for (const e of this.extensions)
      await ((t = this[e]) == null ? void 0 : t._initialize(this));
    l(a.INIT);
  }
  async _setAccessToken(t, e, o = !0) {
    f(_, e), o && f(d, t), this.accessToken = t, this.loginProvider = e, l(a.LOGIN);
  }
  _setRefreshToken(t) {
    f(g, t), this.refreshToken = t;
  }
  getRefreshToken() {
    return this.refreshToken;
  }
  getAccessToken() {
    return this.accessToken;
  }
  getLoginProvider() {
    return this.loginProvider;
  }
  isLoggedIn() {
    return !!this.accessToken && !!this.loginProvider;
  }
  logout() {
    I(d), I(g), this.accessToken = null, this.refreshToken = null, this.loginProvider = null, l(a.LOGOUT);
  }
}
s(O, "SDK_ENV", E), s(O, "SDK_EVENT", a);
export {
  O as CredenzaSDK
};
